import React from 'react'
import PropTypes from 'prop-types'
import PopoverOnClick from 'components/Utils/Popover/PopoverOnClick'

class EditorOverlay extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    popoverContent: PropTypes.node.isRequired,
  }
  render() {
    return (
      <PopoverOnClick
        position="bottom"
        content={
          <div
            className="zindex-large radius-normal scroll-y background-shade-100 border-none shadow-hovering"
            contentEditable={false}
          >
            {this.props.popoverContent}
          </div>
        }
      >
        {this.props.children}
      </PopoverOnClick>
    )
  }
}

export default EditorOverlay
